import { Permissions, PlatformFeature } from "app/shared/objects/user";

export class User {
  name: string;
  email: string;
  companyName: string;

  get firstName(): string {
    return this.name ? this.name.split(' ')[0] : '';
  }
}

export class UserInfo {
  acceptedTerms: boolean;
  activated: boolean;
  city: string;
  cityId: string;
  defaultGoalDate: Date;
  email: string;
  firstName: string;
  id: string;
  name: string;
  networkBackgroundUrl: string;
  networkLogoUrl: string;
  networkName: string;
  paymentStatus: string;
  profile: string;
  propertyId: string;
  propertyIds: string[];
  propertyName: string;
  role: string;
  roles: string[];
  userPlan: string;
  permissions?: Permissions;
  platformFeatures: PlatformFeature[];
  pendingPayment: boolean;
  hasPlan: boolean;
  suspendedPayment: boolean;
  subscriptionSuspensionDate: Date;
  planId?: string;

  isPublicAdministrator(): boolean {
    return this.roles && this.roles.find(r => r === 'PUBLIC_ADMINISTRATOR') !== undefined;
  }

  isSolutionProvider(): boolean {
    return this.roles && this.roles.find(r => r === 'SOLUTION_PROVIDER') !== undefined;
  }
}
